<div class="p-grid">
    <div class="p-col-12">
        <div class="p-col-12 page-header">Data Mining</div>
        <div class="p-col-12 divider-header">
            <p-divider></p-divider>
        </div>
        <div class="card">
            <div class="">
                <div class="p-grid">
                    <div class="p-col-12 p-lg-6 p-md-6">
                        <div class="p-inputgroup">
                            <input type="search" pInputText [(ngModel)]="searchStr" placeholder="Search Transactions" (keyup.enter)="searchTransactions()">
                            <p-button styleClass="fullwidthbtn" icon="pi pi-search" (click)="searchTransactions()"></p-button>
                        </div>
                    </div>
                    <div class="p-col-12" *ngIf="showLanguage==true">
                        <strong>This page will allow you to search for closed NAI transactions via NAI Office name, seller name, buyer name or property type. If you wish to download a report or import newly closed transactions, please have your office manager follow the steps provided here. For questions, please email help@naiglobal.com.</strong>
                    </div>
                </div>
            </div>
            <p-table #dt *ngIf="transactions.length>0"
                     styleClass="p-datatable-items"
                     [columns]="transCols"
                     [value]="transactions"
                     dataKey="Id"
                     [paginator]="true"
                     [rows]="10"
                     [rowHover]="true"
                     [showCurrentPageReport]="true"
                     [rowsPerPageOptions]="[10,25,50]"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                     [filterDelay]="0"
                     [globalFilterFields]="['NaiOffice','PropertyType','SellerLegalName','BuyerLegalName', 'Location']"
                     exportFilename="DataMining">
                <ng-template pTemplate="caption">
                    <div class="table-header">
                        <span>
                            <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV()" class="p-button-info p-mr-2" pTooltip="Download CSV File" tooltipPosition="bottom"></button>
                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2" pTooltip="Download XLS File" tooltipPosition="bottom"></button>
                        </span>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Filter" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of transCols" [ngStyle]="{'display': col.display}">
                            <strong>
                                {{col.header}}
                            </strong>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-tran>
                    <tr>
                        <td *ngFor="let col of transCols" [ngStyle]="{'display': col.display}">
                            {{tran[col.field]}}
                        </td>
                        <td style="text-align: center">
                            <button pButton type="button" class="p-button-primary" (click)="navToDetail(tran)" label="Detail"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
